import { Avatar, Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { B2CCallHeadphone } from 'Images';

export const Outro = () => {
  return (
    <Stack
      direction='row'
      alignItems='center'
      justifyContent='center'
      gap='8px'
    >
      <Avatar
        alt=''
        src={B2CCallHeadphone}
        sx={{ width: '27px', height: '27px' }}
      />
      <Typography variant='body6'>
        {Dictionary[DICTIONARY.B2C].Landing.outro}
      </Typography>
    </Stack>
  );
};
